<template>
  <a :href="'/features/' + feature.id" class="post">
    <div class="postHeader" :style="'background-image: url(\'' + thumbnail + '\');background-position: top;background-color: #ffffff;'"></div>
    <div class="postFooter">
      <h2 class="postTitle">{{ feature.title }}</h2>
      <div class="postFooterFooter">
        <div class="postDate">
          <i class="material-icons post-pc">access_time</i>
          <div class="post-pc">{{ feature.updated_at.substring(0, 10) }}</div>
          <div class="post-sp">{{ date }},</div>
        </div>
        <div class="postAuthor"><i class="material-icons post-pc">person</i> {{ writer }}</div>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: [
      'feature',
      'thumbnail',
      'writer',
      'date',
    ]
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  .post-sp{display: none !important;}
  // Medium ~
  @media (min-width:751px){
    .post{margin:0 10px 20px; color: $cText; background: white; cursor: pointer;
      &:link,
      &:visited{ color:$cText;}
      &Header{position:relative;height:calc(((100vw - 60px) / 4 - 10px * 2) * 9 / 16);background-size: 100% auto;
        &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{padding:10px 15px 20px;
        // &Footer{display:flex;}
      }
    &Title{align-items: flex-start; overflow: hidden; max-height: 3em; margin-bottom: 5px; font-size: 16px;font-weight: bold;}
      &Date{margin-bottom:10px;}
      &Date,
      &Author{@include centerY; margin-right: 20px; font-size: 10px; line-height: 1; color: cText(40);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
        i{margin-right: 3px; font-size: 1.4em;}
      }
      &:hover{opacity:1;
        .postHeader::after{background: cBaseDk(0);}
      }
    }
  }
  @media screen and (min-width: 751px) and (max-width: 1024px){
    .post{
      &FooterFooter{display: flex;}
      &Date{margin-bottom: 0;}
      &Date,
      &Author{width: 100%;}
    }
  }
  // Small
  @media screen and (max-width:750px){
    .post{padding: 10px 0; color: $cText; cursor: pointer;
      &:link,
      &:visited{ color:$cText;}
      &Header{position:relative; width:35%; background-size: 100% auto; height: calc((100vw - 20px) * 0.35 * 0.6);background-position: center !important;background-color:#EFEFEF !important;
        &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{padding-left:20px; width:65%;
        &Footer{display:flex;}
      }
      &Title{align-items: flex-start; overflow: hidden; max-height: 3em; font-weight: bold;}
      &-pc{display: none !important;}
      &-sp{display: block !important;}
      &Date,
      &Author{@include centerY; margin-right: 10px; font-size: 10px; line-height: 1; color: cText(40);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
        i{margin-right: 3px; font-size: 1.4em;}
      }
      &:hover{opacity:1;
        .postHeader::after{background: cBaseDk(0);}
      }
    }
  }
</style>
